import { useCallback } from 'react';

import { useToast as useToastBase } from '@bonusly/design-system';

import { Toast, ToastStatus } from '../components/common/toast';

type CreateToastArgs = {
	isCloseable?: boolean;
	duration?: number;
	message: string;
	status?: ToastStatus;
};

export const useToast = () => {
	const toast = useToastBase();

	const createToast = useCallback(
		({ isCloseable = true, message, status, ...args }: CreateToastArgs) =>
			toast({
				position: 'bottom-right',
				render: (props) => <Toast isCloseable={isCloseable} message={message} status={status as any} {...props} />,
				...args,
			}),
		[toast]
	);

	const createErrorToast = useCallback((message: string) => createToast({ message, status: 'error' }), [createToast]);

	const createInfoToast = useCallback((message: string) => createToast({ message, status: 'info' }), [createToast]);

	const createSuccessToast = useCallback((message: string) => createToast({ message, status: 'success' }), [createToast]);

	return {
		createErrorToast,
		createInfoToast,
		createSuccessToast,
		createToast,
	};
};
